<template>

  <div>

    <!-- page-heading -->
    <page-heading pageTitle="APOPOINT-APOPOINTS-OVERVIEW-HEADER"></page-heading>

    <pharmacies
      ref="pharmacies"
      apiURL="site/apopoint"
      routeDetailName="apopointDetail"
      :showSearch="true"
      :activeFilters="[]"
      :tblColumns="['id', 'extRef', 'name', 'location', 'apoPointType', 'erp', 'payment', 'server', 'offersCount', 'orderCount', 'apopointDevUrl', 'apopointUrl']"
      :tblSortColumns="['extRef', 'name', 'location', 'apoPointType', 'erp', 'payment', 'server', 'offersCount', 'orderCount']"
      :tblOptions="{ perPage: 15 }">
    </pharmacies>

  </div>

</template>


<script>
import pharmacies from '../utils/incl-pharmacies';

export default {

  name: 'Apopoints',

	components: {
    pharmacies
	},

	data() {
		return {

    }
  }

}

</script>


<style lang="scss" scoped>

</style>
